import styled from 'styled-components'
import { Heading } from '@lmc/ui-kit'

type SectionHeaderProps = {
  title: string
  className?: string
}

export const SectionHeader = ({ title, className }: SectionHeaderProps) => {
  return <StyledHeading level={2} className={className}>{title}</StyledHeading>
}

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color3};
  font-weight: 500;
`
